import { Fragment, useState, useCallback, useRef, useMemo } from "react";
import Dialog from "../../atoms/dialog";
import Slide from "@material-ui/core/Slide";
import ImportViewer from "../bluePrintComponents/ImportViewer";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import { importFromTemplateBlueprint } from "../../../store/blueprint/actions";
import { updateBlueprintSlugDetails, setLoadingFalse, invokeGetService } from "../../../store/global/actions";
import TextField from "@material-ui/core/TextField";
// import { setLoadingFalse } from '../../../store/blueprint/actions'
// import { updatedDefaultSelectedTransaction } from '../../../store/blueprint/dataflow/actions'
import CustomBlueprintImporter from '../bluePrintComponents/CustomBlueprintImporter'
import { updateStateData, uploadCustomBlueprintJson } from '../../../store/blueprint/actions'
import { Alert } from '@material-ui/lab';
import { validateBlueprintName } from '../bluePrintComponents/SystemModel/helpers';
import { getHistoryData } from "../../../store/history/selectors";
import { controlDelegate } from '../../../config/control_delegate';
import { sanitizeEventAttributes } from '../../../services/entities/event';
import { setBlueprintDataToLocalStorage } from '../../../services/blueprint';
import { invokePostService } from '../../../store/global/actions';
import { Checkbox, FormControl, FormControlLabel, Grid, InputLabel, makeStyles, MenuItem, Select } from "@material-ui/core";
import BlueprintCreateButtons from "../../atoms/buttons/BlueprintCreateButtons";
import { findIconSource, generateIconFileName, validateNonAsciiChars } from "../../../utils/commonUtils";
import { IconSelector } from "../../atoms/IconSelectorV2";

const createOptions = [
	// { id: "import-blueprint", _id: "import-blueprint", name: "Template", description: "Start your blueprint from a template.", doNotStrip: true },
	{ id: "new-blueprint", _id: "new-blueprint", name: "New", description: "Create your blueprint from an empty canvas.", doNotStrip: true },
	{ id: "import-custom-blueprint", _id: "import-custom-blueprint", name: "Import", description: "Import a blueprint from your local disk.", doNotStrip: true },
]

const useStyles = makeStyles((theme) => ({
	// Define your custom styles here
	textCapitalise: {
		textTransform: 'capitalize' 
	},
	formControl: {
		minWidth: 120,
		width: "100%"
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},

	buttonsContainer: {
		// display: 'grid',
		// gridTemplateColumns: 'repeat(2,1fr)',
		display: 'flex',
		justifyContent: 'space-evenly'
	}
  }));
  

const log = console.log;
const SelectBluePrintImport = (props) => {
	const classes = useStyles();

	const [, updateState] = useState();
	const forceUpdate = useCallback(() => updateState({}), []);
	const selectedBlueprint = useRef();
	const selectedBlueprintName = useRef('');
	const dispatch = useDispatch();
	const [selectedOption, setSelectedOption] = useState("");
	const [step, setStep] = useState(0);
	const [cloneImport, setCloneImport] = useState(false);
	const [loading, setLoading] = useState(false);
	const { open, gotocreate, handleClose } = props;
	const [importError, setImportError] = useState('')
	const [importProgress, setImportProgress] = useState('')
	const [descError, setDescError] = useState(null)


	const historyData = useSelector(getHistoryData);


	const goForward = () => setStep((prev) => {
		if (selectedOption == 'new-blueprint'){
			return prev + 2
		}else if (selectedOption == 'import-custom-blueprint'){
			return prev + 3
		}else{
			return prev + 1
		}
	});

	const goBack = () => setStep((prev) => {
		setImportError('')
		if (selectedOption == 'new-blueprint')
			return prev - 2
		else if (selectedOption == 'import-custom-blueprint')
			return prev - 3
		else {
			return prev - 1
		}

	});

	const onClick = (value) => {
		if (value === 'import-blueprint') {
			setStep(1)
		}
		if (value === 'import-custom-blueprint') {
			setStep(3)
		}
		if (value === 'new-blueprint') {
			setStep(2)
		}
		setSelectedOption(value);
	}

	const [cloneBlueprintName, setCloneBlueprintName] = useState('')
	const [cloneBlueprintDesc, setCloneBlueprintDesc] = useState('')
	const [importBpOptionsValidation, setImportBpOptionsValidation] = useState('')
    const [availableVersions, setAvailableVersions] = useState([]);
	const [isSameVersion, setIsSameVersion] = useState(false);

	const [customBlueprintDesc, setCustomBlueprintDesc] = useState('')
	const [customBlueprintFile, setCustomBlueprintFile] = useState('')
	const [invalidFile, setInvalidFile] = useState(false)

	const isStepOne = step === 1;
	const isStepTwo = step === 2;
	const isStepZero = step === 0;
	const isStepThree = step === 3;
	const isStepTwoOrThree = (step == 2 || step == 3)

	const isImportStep = (selectedOption === "import-blueprint") ? isStepOne : isStepTwo;
	const isCustomImportStep = (selectedOption === "import-custom-blueprint") ? isStepThree : isStepOne;

	const [isAutofill, setIsAutofill] = useState(false);
	const [isAutocapture, setIsAutocapture] = useState(false);
	const [icon, setIcon] = useState(null);

	const handleBlueprintSave = (blueprintBasic) => {
		let url = blueprintBasic.slug + '/' + blueprintBasic._id

		dispatch(setLoadingFalse())
		gotocreate(url)
	}

	const setCustomBlueprintName = (value) => {
		selectedBlueprintName.current = value
	}

	const onImportClick = async () => {
		try {
			setImportError('');
			let blueprintNameInfo = validateBlueprintName(selectedBlueprintName.current);
			if (selectedOption === "new-blueprint") {
				if (blueprintNameInfo?.length) {
					setImportError(blueprintNameInfo);
					return;
				}

				setLoading(true);

				const configuration = {
					autoFill: isAutofill,
					autoCapture: isAutocapture
				}

				const payload = {
					name: selectedBlueprintName.current,
					description: customBlueprintDesc,
					controller: controlDelegate, 
					configuration: configuration
				}

				if(icon){
					payload.icon = generateIconFileName(icon);
					payload.iconSource = findIconSource(icon);
				}

			
				dispatch(invokePostService('createBlueprint', payload)).then(res => {
					setLoading(false);
					if (res?.status && res?.data) {
						dispatch(updateBlueprintSlugDetails(res.data));
						handleBlueprintSave(res.data);
					} else {
						setImportError(res.message);
					}
				});


			} else if (selectedOption === "import-blueprint") {
				blueprintNameInfo = validateBlueprintName(cloneBlueprintName);
				if (importBpOptionsValidation === false) return
				if (blueprintNameInfo?.length) {
					setImportError(blueprintNameInfo);
					return;
				}

				setLoading(true);
				setImportProgress('Importing blueprint...')

				// from applications folder import
				// let res = await dispatch(importFromTemplate(selectedBlueprint.current, cloneBlueprintName));

				// from template blueprint databse import
				let res = await dispatch(importFromTemplateBlueprint(selectedBlueprint.current, cloneBlueprintName, cloneBlueprintDesc))
			
				if (res.status == false) {
					//setImportError('Could not import the blueprint. Please try again')
					setImportError('Blueprint name already exists. Please try with other name')
					setImportProgress('');
					setLoading(false);
					return false
				}

				if (res.status == true) {

					/**sanitize events to update onrecv and onsend handlers in event */
					const constructs = sanitizeEventAttributes(res.data.blueprint.constructs)
					res.data.blueprint.constructs = constructs;
					setBlueprintDataToLocalStorage(res.data?.id, constructs, res.data?.blueprint?.views, res.data?.blueprint?.updatedAt);
					dispatch(updateStateData(res.data));
					handleBlueprintSave(res.data);

				}


			} else if (selectedOption === "import-custom-blueprint") {
				if (blueprintNameInfo?.length) {
					setImportError(blueprintNameInfo);
					return;
				}
				if (customBlueprintFile === '') {
					setImportError('Please select a file');
					return;
				}
				let formData = new FormData();

		
				setLoading(true);
				formData.append('blueprintName', selectedBlueprintName.current)
				formData.append('blueprintDescription', customBlueprintDesc)
				formData.append('blueprintFolder', customBlueprintFile)

				if(icon){
					formData.append('icon', generateIconFileName(icon));
					formData.append('iconSource', findIconSource(icon));
				}

				setImportProgress('Uploading blueprint...')
				// upload of blueprint ruby and lua files
				// let result = await dispatch(uploadCustomBlueprint(formData, selectedBlueprintName.current))

				const validationResult = await dispatch(invokePostService('validateBlueprintName', { blueprintName: selectedBlueprintName.current }))
				if(validationResult.status){
					// upload of react-redux store data
					let result = await dispatch(uploadCustomBlueprintJson(formData, selectedBlueprintName.current))

					if (result.status === false && result?.alreadyExist === false) {
						setImportError('Failed to import the blueprint. Please check the blueprint for syntax errors.')
						setImportProgress('');
						setLoading(false);
						return false
					}

					if (result.status === false) {
						setImportError('Failed to import the blueprint. Please check the blueprint for syntax errors.')
						setImportProgress('');
						setLoading(false);
						return false
					}


					if (result.status === true) {
						handleBlueprintSave(result.data);
					}
				}else{
					if(validationResult?.alreadyExist){
						setImportError('Blueprint name already exists. Please try another name.')
						setImportProgress('');
						setLoading(false);
						return false;
					}else{
						setImportError('Failed to import the blueprint. Something went wrong')
						setImportProgress('');
						setLoading(false);
						return false
					}
				}

			}
		} catch (error) {
			log(`Blueprint import failed. ${error}`);
		}
	};

	const handleDescription = (e) => {
		if(validateNonAsciiChars(e.target.value) !== true){
			setDescError(validateNonAsciiChars(e.target.value))
		}else{
			setDescError(false)
		}
		setCustomBlueprintDesc(e.target.value);
	};
	
	const optionSelectorProps = {
		selectedOption,
		onClick,
	};
	const importViewerOptions = {
		selectedBlueprint,
		forceUpdate,
		setCloneBlueprintName,
		setCloneBlueprintDesc,
		setImportBpOptionsValidation,

	};

	const customImportViewerOptions = {
		setCustomBlueprintName,
		setCustomBlueprintDesc,
		setCustomBlueprintFile,
		setInvalidFile,
		setImportError,
		selectedBlueprintName,
		setIsSameVersion
	}

	const disableNextButton = () => {

		

		if (!selectedOption) return true;
		if (loading) return true;
		if (isStepOne && selectedOption === "import-blueprint" && !selectedBlueprint.current) return true;
		if (invalidFile) return true;
		if (importBpOptionsValidation === false && isImportStep) return true
		// if ((( blueprintNameValidation == false) || (isBpName==false)) &&  (isImportStep || isCustomImportStep)) return true;
		return false;
	};

	const getPlatformSchema = async () => {
        const response = await dispatch(invokeGetService('platformSchemaAvailableVersions'));

        if(response?.status){
            setAvailableVersions(response?.data);
        }
    }

    useMemo(() => {
        getPlatformSchema();
    },[])

	  

	return (
		<Fragment>
			<Dialog
				title="Blueprint"
				container_id="blueprint-create-modal"
				open={open}
				paperProps={{ style: { overflow: "visible" } }}
				handleClose={handleClose}
				actions={
					<Fragment>
						<Button variant="outlined" autoFocus color="primary" onClick={isStepZero ? handleClose : goBack} className={classes.textCapitalise}>
							{isStepOne || isStepTwo || isStepTwoOrThree ? "Back" : "Close"}
						</Button>
						{(isStepOne || isStepTwo || isStepThree) && <Button
							endIcon={loading ? <CircularProgress size={14} /> : <Fragment />}
							disabled={disableNextButton()}
							variant="contained"
							autoFocus
							color="primary"
							onClick={isImportStep || isCustomImportStep ? onImportClick : goForward}
							className={classes.textCapitalise}
							data-ui-tour-id='create-new-bp-btn'
						>
							{loading ? 'Creating..' : isImportStep || isCustomImportStep ? "Create" : "Next"}
						</Button>}
					</Fragment>
				}
				step={step}
			>

				{importError != '' && <>
				<Alert severity="error">{importError}</Alert>
				<br />
				</>}
				{importProgress != '' && <>
					<Alert icon={<CircularProgress size={14} />} severity="info">{importProgress}</Alert>
					<br />
				</>}

				{step === 0 && (
					<Slide direction="right" in={step === 0} mountOnEnter unmountOnExit>
						<div onmouseover="show()" onmouseout="hide()" title="Click to continue">
							<OptionSelector {...optionSelectorProps} />
						</div>
					</Slide>
				)}
				{step === 1 && (
					<Slide direction="right" in={step === 1} mountOnEnter unmountOnExit>
						<div>
							<ImportViewer {...importViewerOptions} />
						</div>
					</Slide>
				)}

				{step === 2 && (
					<Slide direction="right" in={step === 2} mountOnEnter unmountOnExit>
						<div>
							<Grid container xs={12} style={{gap: '1rem', flexWrap: 'nowrap'}}>
								<Grid item xs={12}>
									<TextField
										id="blueprint_name"
										InputLabelProps={{
											shrink: true,
										}}
										autoFocus
										type={"text"}
										fullWidth
										required
										label={"Blueprint Name"}
										placeholder={"Blueprint Name"}
										variant="outlined"
										name={"blueprintName"}
										inputProps={{
											pattern: "^S+$",
											'data-ui-tour-id': 'bp-name-field'
										}}
										onChange={(event) => {
											selectedBlueprintName.current = (event.target.value || "")
										}}
									/>
								</Grid>
							</Grid>
							<br />
							<TextField
								InputLabelProps={{
									shrink: true,
								}}
								type={"text"}
								fullWidth
								// label="Multiline"
								multiline
								rows={4}
								id="blueprint_desc"
								label={"Description"}
								placeholder={"Description"}
								variant="outlined"
								name={"Description"}
								onChange={handleDescription}
								error={descError ? true : false}
								helperText={descError || ''}
								inputProps={{
									'data-ui-tour-id': 'bp-description-field'
								}}
							/>
							<br />
							<FormControlLabel className="autoFill"
								control={
									<Checkbox 
										inputProps={{
											'data-ui-tour-id': 'bp-autofills-field'
										}} 
										checked={isAutofill} 
										onChange={e => {
											setIsAutofill(e.target.checked)
										}}  
										name={"autoFill"} 
									/>
								}
								label="Autofill"
							/>
							<FormControlLabel className="autoCapture"
								control={
									<Checkbox 
										inputProps={{
											'data-ui-tour-id': 'bp-autocapture-field'
										}}  
										checked={isAutocapture} 
										onChange={e => {
											setIsAutocapture(e.target.checked)
										}}  
										name={"autoCapture"}
									/>
								}
								label="Auto capture"
							/>
							
							<IconSelector isBlueprintCreate={true}  setSelectedIcon={setIcon} selectedIcon={icon}  defaultSearchTag={""}/>
							
						</div>
					</Slide>
				)}

				{step === 3 && (
					<Slide direction="right" in={step === 3} mountOnEnter unmountOnExit>
						<div>
							<CustomBlueprintImporter setIcon={setIcon} icon={icon} loading={loading} setLoading={setLoading} availableVersions={availableVersions} {...customImportViewerOptions} />
						</div>
					</Slide>
				)}

			</Dialog>
		</Fragment>
	);
};

export default SelectBluePrintImport;

const OptionSelector = (props) => {
	const { onClick, selectedOption } = props;
	const classes = useStyles()

	return (
		<Fragment>
			<div className={classes.buttonsContainer}  style={{}}>
				{
					createOptions.map((option) => (
						<BlueprintCreateButtons data={option} onClick={onClick}/>
					))
				}
			</div>
			{/* <CardSelector
				actionsButtons
				list={}
				onClick={onClick}
				value={selectedOption}
			/> */}
		</Fragment>
	);
};